module.exports = __webpack_public_path__ + "img/mexico.19524836.png";